import onLogError from './onLogError';
import { PAGE_TYPE } from '../constants/logger';

const getInjector = async (page) => {
  try {
    await window.APP_EXTENSION_SDK_ANGULAR_JS_LOADED;
  } catch (error) {
    onLogError({
      sourceName: 'getInjector',
      page: PAGE_TYPE[page] || page,
      error,
    });

    return undefined;
  }

  return window.angular.element(document.body)?.injector();
};

export default getInjector;
